import { lazy } from 'react';
import { retry } from '../../config/utils';

const Thankyou = lazy(() =>  retry(()=> import(/* webpackChunkName: "thankyou" */ "./index")));

export default Thankyou;